import { Routes } from '@angular/router';
import { CreateEditUserComponent } from './main/pages/users/create-edit-user/create-edit-user.component';
import { UserListComponent } from './main/pages/users/user-list/user-list.component';
import { AuthGuard } from './auth.guard';
import { ConsultationComponent } from './main/pages/consultation/consultation.component';
import { PatientListComponent } from './main/pages/patient/patient-list/patient-list.component';
import { PatientDetailComponent } from './main/pages/patient/patient-detail/patient-detail.component';
import { PatientCaseCardComponent } from './main/pages/patient/patient-case-card/patient-case-card.component';
import { ApsComponent } from './main/pages/consultation/aps/aps.component';
import { DashboarMainComponent } from './main/pages/dashboard/dashboar-main/dashboar-main.component';
import { ConsultationListComponent } from './main/pages/consultation/consultation-list/consultation-list.component';
import { ConsultationDetailComponent } from './main/pages/consultation/consultation-detail/consultation-detail.component';
import { ForgotPasswordComponent } from './main/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './main/pages/reset-password/reset-password.component';
import { LoginComponent } from './main/pages/login/login.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: 'dashboard',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'main', component: DashboarMainComponent },
      { path: '**', redirectTo: 'main' },
    ],
  },
  {
    path: 'user',
    component: ConsultationComponent,
    children: [
      { path: 'list', component: UserListComponent },
      { path: 'create', component: CreateEditUserComponent },
      { path: 'edit/:id', component: CreateEditUserComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'consultation',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: ConsultationListComponent },
      { path: 'detail/:id', component: ConsultationDetailComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'patient',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: PatientListComponent },
      { path: 'a-p-s', component: ApsComponent },
      { path: 'detail/:id', component: PatientDetailComponent },
      {
        path: 'new-patient-case-card/:id',
        component: PatientCaseCardComponent,
      },
      { path: 'add-patient-case-card', component: PatientCaseCardComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  { path: '**', redirectTo: '/login' },
];
